import { Pipe, PipeTransform } from '@angular/core';
import { fullName } from '../utils/full-name';

@Pipe({
    name: 'fullName',
    standalone: false
})
export class FullNamePipe implements PipeTransform {

  public transform(value: any): string {
    return fullName(value);
  }

}
